import { EntityChildCreateModal } from '@/pages/admin/shared/entity-management/EntityChildCreateModal';

type CategoryOption = { id: string; name: string };

type CreateSubcategoryModalProps = {
	isOpen: boolean;
	onClose: () => void;
	categories: CategoryOption[];
	defaultCategoryId?: string;
	onCreate: (categoryId: string, subcategoryName: string) => void;
};

export const CreateSubcategoryModal = ({
	isOpen,
	onClose,
	categories,
	defaultCategoryId = '',
	onCreate,
}: CreateSubcategoryModalProps) => {
	return (
		<EntityChildCreateModal
			isOpen={isOpen}
			onClose={onClose}
			options={categories}
			defaultOptionId={defaultCategoryId}
			title="Criar subcategoria"
			description="Vincule uma nova subcategoria a uma categoria existente."
			selectLabel="CATEGORIA"
			selectPlaceholder="Selecione uma categoria"
			childLabel="NOME DA SUBCATEGORIA"
			childPlaceholder="Ex: Saúde mental"
			submitText="Criar subcategoria"
			selectId="form-modal-subcat-cat"
			inputId="form-modal-subcat-name"
			onCreate={onCreate}
		/>
	);
};
